export enum TaminServicesType {
  all = ' ',
  laboratory = '02',
  radiology = '03',
  sonography = '04',
  ctScan = '05',
  MRI = '06',
  nuclearMedicine = '07',
  angiography = '11',
  physiotherapy = '13',
  boneDensitometry = '14',
  referralService = '17',
}
